export default __webpack_public_path__ + "static/media/logo.32e9ec92.png";